"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Span = function defaultSpan(_ref) {
  var content = _ref.content,
      currentClass = _ref.currentClass;

  if (content) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: currentClass
    }, content.split('\n').reduce(function (acc, currentP) {
      if (acc.length === 0) {
        return [currentP];
      }

      var brIndex = (acc.length + 1) / 2 - 1;

      var br = /*#__PURE__*/_react["default"].createElement("br", {
        key: brIndex
      });

      return acc.concat([br, currentP]);
    }, []));
  }

  return null;
};

Span.propTypes = {
  content: _propTypes["default"].string.isRequired,
  currentClass: _propTypes["default"].string.isRequired
};
var _default = Span;
exports["default"] = _default;